function getParameterByName(name) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var url = window.location.href;
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    var results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

function notif(status = 1, message){
    let alert = 'Alert--success'
    if(status != 1){
        alert = 'Alert--error'
    }

    var t = document.createElement("span");
    t.className = `Alert ${alert} all-notif`, t.innerHTML = message;

    $("body").prepend(t)
    setTimeout(() => {
        t.className += " active";
    }, 200);
    setTimeout(function() {
        t.classList.remove("active");
        setTimeout(() => {
            t.remove()
        }, 500);
    }, 2700)
}

function checkMember(memberBaseUrl, dataToPost){
    $.ajax({
        type: "POST",
        url: memberBaseUrl + "member/getMemberOnWebsite",
        data: dataToPost,
        success: function(response){
            let data = JSON.parse(response)
            if(data['status'] != 200){
                notif(2, "You're not regitered as member")
                setTimeout(() => {
                    location.href = `https://${Shopify.shop}`
                }, 1500);
            }
        }
    });
}